module.exports = ":host ::ng-deep .mat-tab-body-content {\n  overflow-y: hidden; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/common/components/slide-form/slide-form.component.scss
// module id = ./libs/atenea-cms-brand/src/common/components/slide-form/slide-form.component.scss
// module chunks = main